export enum KnowledgeType {
    Knowledge = 'knowledge',
    Document = 'document',
    Record = 'record',
}

export enum DocumentType {
    Pdf = 'pdf',
    Text = 'text',
    Html = 'html',
    Word = 'word',
    Json = 'json',
    Markdown = 'markdown',
    Csv = 'csv',
    Excel = 'excel',
    Powerpoint = 'powerpoint',
    Archive = 'archive',
    Image = 'image',
    Audio = 'audio',
    Video = 'video',
}

export interface IKnowledge {
    vector_store: string;
    type: KnowledgeType;
    description: string;
    created_by?: string;
    name: string;
}

export interface IKnowledgeDocument {
    documentType: DocumentType;
    title: string;
    source_url: string;
    created_at?: Date;
    id?: string;
}

export enum KnowledgeStatus {
    Done = 'done',
    Error = 'error',
    Indexing = 'indexing',
    Processing = 'processing',
}
